import { Table, TableCell, TableRow } from '@material-ui/core';
import styled from 'styled-components';

export const InstyleTable = styled(Table)(({theme}) => ({
    '& td': {
        fontSize: '12px'
    },
}))

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '& td': {
    border: 'none'
  },
  border: 'none'
}));

export const AlternateStyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: "white",
  },
  '&:nth-of-type(even)': {
    backgroundColor: "grey",
  },
  '& td': {
    border: 'none'
  },
}));

export const AddonAlternateRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(even)': {
        backgroundColor: "white",
    },
    '&:nth-of-type(odd)': {
        backgroundColor: "#FFF2CC",
    },
    '& td': {
        border: 'none'
    },
}))

const InstyleCell = styled(TableCell)(({theme}) => ({
    fontSize: '12px',
    padding: '8px'
}))

export const CellNoBorder = styled(InstyleCell)(({theme}) => ({
    border: 'none'
}))

export const CellWhiteBorder = styled(InstyleCell)(({theme}) => ({
    border: '1px solid white'
}))

export const BlackCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: 'black',
    color: 'white'
}))

export const BlackCellBorderWhite = styled(BlackCell)(({theme}) => ({
    border: '1px solid white !important'
}))

export const GreenCell = styled(CellNoBorder)(({theme}) => ({
    backgroundColor: '#E2EFDA'
}))

export const DarkGreenCell = styled(CellNoBorder)(({theme}) => ({
    backgroundColor: '#70AD47'
}))

export const DarkGreyCell = styled(CellNoBorder)(({theme}) => ({
    backgroundColor: '#595959',
    color: 'white'
}))

export const DarkGreyCellBorder = styled(DarkGreyCell)(({theme}) => ({
    border: '1px solid white !important'
}))

export const LightGreyCell = styled(CellNoBorder)(({theme}) => ({
    backgroundColor: '#DCDADA'
}))

export const BlueGreyCell = styled(BlackCellBorderWhite)(({theme}) => ({
    backgroundColor: '#44546A'
}))

export const BrightYellowCell = styled(CellWhiteBorder)(({theme}) => ({
    backgroundColor: '#FFDD00',
}))

export const BrightYellowCellBorder = styled(BrightYellowCell)(({theme}) => ({
    border: '1px solid white !important'
}))

export const LightYellowCell = styled(CellWhiteBorder)(({theme}) => ({
    backgroundColor: '#FFF2CC',
}))

export const LightYellowCellBorder = styled(LightYellowCell)(({theme}) => ({
    border: '1px solid white !important'
}))

export const YellowCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: '#FFC000',
    color: 'black'
}))

export const TableSelect = styled('select')(({theme}) => ({
    border: 'none',
    backgroundColor: 'transparent',
}))

export const TableInput = styled('input')(({theme}) => ({
    background: 'transparent',
    border: 'none',
}))

export const QtyInput = styled(TableInput)(({theme}) => ({
    maxWidth: '50px'
}))

export const BlueCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: '#2F75B5',
    color: 'white'
}))

export const DarkBlueCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: '#2F75B5'
}))

export const DarkBlueCellBorder = styled(DarkBlueCell)(({theme}) => ({
    border: '1px solid white !important'
}))

export const LighterBlueCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: '#DDEBF7',
}))

export const LightBlueCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: '#9BC2E6'
}))

export const LightBlueCellBorder = styled(LightBlueCell)(({theme}) => ({
    border: '1px solid white !important'
}))

export const OrangeCell = styled(InstyleCell)(({theme}) => ({
    backgroundColor: '#C65911',
    color: 'black'
}))